
import Vue from "vue";
import gql from "graphql-tag";
import { callApi } from "@/lib/api";
import crypto from "crypto";
import TextField from "@/components/molecules/TextField.vue";
import PremiumInformation from "@/components/atoms/PremiumInformation.vue";
import { Plan } from "@/lib/models";

export default Vue.extend<Data, Methods, Computed, Props>({
  components: { TextField, PremiumInformation },
  props: {
    novelId: String,
    value: Object,
  },
  created() {
    if (!this.value) {
      return;
    }
    this.name = this.value.name;
    const { detail } = this.value as { detail: any[] };
    if (!detail) {
      return;
    }
    this.detail = this.detail.map((x) => {
      let targetValue = x.value;
      const target = detail.find((y) => y.name === x.name);
      if (target) targetValue = target.value;
      return { ...x, value: targetValue };
    });
    const { additionalColumn } = this.value as { additionalColumn: any[] };
    if (!additionalColumn || additionalColumn.length === 0) {
      return;
    }
    this.additionalColumn = additionalColumn;
  },
  async mounted() {
    const { billingInfo } = await callApi(gql`
      query BillingInfo {
        billingInfo {
          plan
        }
      }
    `);
    this.plan = billingInfo.plan;
  },
  methods: {
    change() {
      const { name, detail, additionalColumn } = this;
      this.$emit("input", {
        name,
        detail: detail.filter(({ value }) => value).map(({ name, value }) => ({ name, value })),
        additionalColumn,
      });
      this.setModified(true);
    },
    add() {
      const { additionalColumn } = this;
      additionalColumn.push({
        name: this.generateUniqueValue(),
        label: "",
        content: "",
      });
      this.change();
    },
    remove(index) {
      const { additionalColumn } = this;
      additionalColumn.splice(index, 1);
      this.change();
    },
    generateUniqueValue() {
      const N = 16;
      return crypto.randomBytes(N).toString("base64").substring(0, N);
    },
  },
  data() {
    return {
      plan: 0,
      name: "",
      detail: [
        {
          name: "period",
          value: "",
          _label: this.$t('createWorldViewPage.periodLabel'),
          _placeholder: this.$t('createWorldViewPage.periodPlaceholder'),
        },
        {
          name: "law",
          value: "",
          _label: this.$t('createWorldViewPage.lawLabel'),
          _placeholder: this.$t('createWorldViewPage.lawPlaceholder'),
          _rows: 4,
        },
        {
          name: "politics",
          value: "",
          _label: this.$t('createWorldViewPage.politicsLabel'),
          _placeholder: this.$t('createWorldViewPage.politicsPlaceholder'),
          _rows: 4,
        },
        {
          name: "military",
          value: "",
          _label: this.$t('createWorldViewPage.militaryLabel'),
          _placeholder: this.$t('createWorldViewPage.militaryPlaceholder'),
          _rows: 4,
        },
        {
          name: "religion",
          value: "",
          _label: this.$t('createWorldViewPage.religionLabel'),
          _placeholder: this.$t('createWorldViewPage.religionPlaceholder'),
          _rows: 4,
        },
        {
          name: "language",
          value: "",
          _label: this.$t('createWorldViewPage.languageLabel'),
          _placeholder: this.$t('createWorldViewPage.languagePlaceholder'),
          _rows: 4,
        },
        {
          name: "other",
          value: "",
          _label: this.$t('createWorldViewPage.otherLabel'),
          _placeholder: this.$t('createWorldViewPage.otherPlaceholder'),
          _rows: 4,
        },
      ],
      additionalColumn: [
        {
          name: (this as any).generateUniqueValue(),
          label: "",
          content: "",
        },
      ],
    };
  },
});

interface Props {
  novelId: string;
  value: {
    name: string;
    detail: any[];
    additionalColumn: any[];
  };
}

interface Data {
  plan: Plan;
  name: string;
  detail: any[];
  additionalColumn: any[];
}

interface Computed {}

interface Methods {
  change(): void;
  add(): void;
  remove(index: number): void;
  generateUniqueValue(): string;
}
